/* ============================================================
   Cart Drawer Horizon — assets/cart-drawer.js
   
   - Ouvre le drawer au clic sur #cart-icon-bubble
   - Ferme via croix, overlay, Escape
   - Update quantités via API AJAX Shopify
   - Suppression d'articles
   - Ajout produit upsell
   - Carousel "Vous aimerez aussi"
   ============================================================ */
(function () {
  'use strict';

  const drawer   = document.getElementById('hn-cart-drawer');
  const overlay  = document.getElementById('hn-cart-overlay');
  const closeBtn = document.getElementById('hn-cart-close');
  const cartTrigger = document.getElementById('cart-icon-bubble');

  if (!drawer) return;

  // ── Ouvrir / Fermer ──────────────────────────────────────
  function openCart() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.classList.add('hn-nav-open'); // bloque scroll body
  }

  function closeCart() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    document.body.classList.remove('hn-nav-open');
  }

  if (cartTrigger) {
    // capture: true → on intercepte AVANT le JS Dawn qui écoute en bubble
    cartTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // bloque tous les autres listeners sur cet élément
      openCart();
    }, true); // capture phase
  }

  // Intercepter aussi tous les liens qui pointent vers /cart
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href="/cart"]');
    if (link) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openCart();
    }
  }, true);

  if (closeBtn)  closeBtn.addEventListener('click', closeCart);
  if (overlay)   overlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCart();
  });

  // ── API Shopify AJAX ─────────────────────────────────────
  async function updateCart(updates) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    return res.json();
  }

  async function addToCart(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] })
    });
    return res.json();
  }

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  // ── Rerender complet du drawer ───────────────────────────
  // Retourne une Promise pour pouvoir être await-ée par les appelants
  function reloadDrawer() {
    return fetch('/?sections=cart-drawer')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (!data['cart-drawer']) return;

        const tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'];

        // Body (liste articles + état vide)
        const newBody = tmp.querySelector('#hn-cart-body');
        const bodyEl  = document.getElementById('hn-cart-body');
        if (newBody && bodyEl) bodyEl.innerHTML = newBody.innerHTML;

        // Footer — remplacer l'ÉLÉMENT entier (outerHTML) pour synchroniser
        // les classes ET le contenu en une seule opération
        const newFooter      = tmp.querySelector('#hn-cart-footer');
        const existingFooter = document.getElementById('hn-cart-footer');
        if (newFooter && existingFooter) {
          existingFooter.replaceWith(newFooter.cloneNode(true));
        }

        // Compteur dans le header du drawer
        const newCount = tmp.querySelector('#hn-cart-count');
        const countEl  = document.getElementById('hn-cart-count');
        if (newCount && countEl) countEl.textContent = newCount.textContent;

        // Badge icône panier dans la navbar
        return getCart().then(function(cart) {
          const badge = document.querySelector('.hn-header__cart-badge');
          if (badge) {
            badge.textContent = cart.item_count;
            badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
          }
          bindEvents();
          initUpsellCarousel();
        });
      })
      .catch(function() {
        window.location.reload();
      });
  }

  async function updateCartBadge() {
    const cart = await getCart();

    // Badge header
    const badge = document.querySelector('.hn-header__cart-badge');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }

    // Titre drawer
    const count = document.getElementById('hn-cart-count');
    if (count) count.textContent = `(${cart.item_count})`;

    // Footer CTA — prix total et visibilité
    const footer = document.getElementById('hn-cart-footer');
    const checkout = document.getElementById('hn-cart-checkout');
    if (footer) {
      footer.classList.toggle('hn-cart-drawer__footer--hidden', cart.item_count === 0);
    }
    if (checkout && cart.item_count > 0) {
      // Formater le prix (Shopify retourne les centimes)
      const price = (cart.total_price / 100).toFixed(2).replace('.', ',');
      checkout.textContent = `Commander ${price} €`;
    }
  }

  // ── Bind events (appellé après chaque rerender) ──────────
  function bindEvents() {
    // Steppers quantité
    document.querySelectorAll('.hn-qty-stepper').forEach(function (stepper) {
      const key = stepper.dataset.key;
      const valEl = stepper.querySelector('.hn-qty-stepper__val');
      const minusBtn = stepper.querySelector('.hn-qty-stepper__btn--minus');
      const plusBtn  = stepper.querySelector('.hn-qty-stepper__btn--plus');

      if (minusBtn) {
        minusBtn.addEventListener('click', async function () {
          const current = parseInt(valEl.textContent, 10);
          if (current <= 1) return; // supprimer via le bouton Supprimer
          valEl.textContent = current - 1;
          await updateCart({ [key]: current - 1 });
          reloadDrawer();
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', async function () {
          const current = parseInt(valEl.textContent, 10);
          valEl.textContent = current + 1;
          await updateCart({ [key]: current + 1 });
          reloadDrawer();
        });
      }
    });

    // Supprimer articles
    document.querySelectorAll('.hn-cart-item__remove').forEach(function (btn) {
      btn.addEventListener('click', async function () {
        const key = btn.dataset.key;
        await updateCart({ [key]: 0 });
        reloadDrawer();
      });
    });

    // Ajouter upsell
    document.querySelectorAll('.hn-upsell-card__add').forEach(function (btn) {
      btn.addEventListener('click', async function () {
        const variantId = parseInt(btn.dataset.variantId, 10);
        btn.disabled = true;
        btn.style.opacity = '0.5';
        await addToCart(variantId);
        reloadDrawer();
      });
    });
  }

  // ── Carousel upsell ──────────────────────────────────────
  function initUpsellCarousel() {
    const track = document.getElementById('hn-upsell-track');
    if (!track) return;

    const cards = track.querySelectorAll('.hn-upsell-card');
    if (cards.length <= 1) return;

    const prevBtn = document.querySelector('.hn-cart-upsell__arrow--prev');
    const nextBtn = document.querySelector('.hn-cart-upsell__arrow--next');
    let current = 0;

    function goTo(index) {
      current = Math.max(0, Math.min(index, cards.length - 1));
      track.style.transform = `translateX(calc(-${current * 100}% - ${current * 12}px))`;
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === cards.length - 1;
    }

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

    goTo(0);
  }

  // ── Intercepter les formulaires add-to-cart de Dawn ─────
  // Dawn soumet le form /cart/add nativement → on intercepte pour garder le drawer
  function initAddToCartForms() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
      // Éviter de binder deux fois
      if (form.dataset.hnBound) return;
      form.dataset.hnBound = 'true';

      form.addEventListener('submit', async function (e) {
        e.preventDefault();

        // Récupérer le bouton submit Dawn
        const submitBtn = form.querySelector('[type="submit"]');

        try {
          const formData = new FormData(form);

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
          });

          if (!res.ok) throw new Error('Add to cart failed');

          // Succès : recharger le contenu du drawer et l'ouvrir
          await reloadDrawer();
          openCart();

        } catch (err) {
          console.error('Add to cart error:', err);
        } finally {
          // Réinitialiser l'état du bouton Dawn (spinner, aria, classes)
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-disabled');
            submitBtn.removeAttribute('aria-busy');
            // Dawn utilise ces classes pour l'état de chargement
            submitBtn.classList.remove('loading', 'disabled');
            // Dawn stocke parfois le texte original dans data-loading-text
            const originalText = submitBtn.querySelector('.btn__text, [data-add-to-cart-text]');
            if (originalText) originalText.style.display = '';
            // Réinitialiser les spinners Dawn
            const spinner = submitBtn.querySelector('.loading__spinner, .svg-animation');
            if (spinner) spinner.style.display = 'none';
          }
        }
      }, true); // capture : avant les listeners Dawn
    });
  }

  // Observer les changements de DOM pour les sections chargées dynamiquement
  const observer = new MutationObserver(function () {
    initAddToCartForms();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // ── Init ─────────────────────────────────────────────────
  bindEvents();
  initUpsellCarousel();
  initAddToCartForms();

})();
